export default __webpack_public_path__ + "static/media/Mobile Screenshot 1.03929ae0.png";